import { Box, Typography } from "@mui/material";
import { CreditCard } from "@phosphor-icons/react";
import { THEME_COLORS, FONT_FAMILY, FONT_SIZE } from "../../util/themes";

interface CreditCardSectionProps {
  onClick: () => void;
}

export default function CreditCardSection({ onClick }: CreditCardSectionProps) {
  return (
    <Box sx={{ mb: 3, cursor: "pointer", display: "flex", alignItems: "center", gap: 1 }} onClick={onClick}>
      <CreditCard size={20} />
      <Typography
        sx={{
          fontSize: FONT_SIZE.sm,
          fontFamily: FONT_FAMILY.primary,
          color: THEME_COLORS.secondary,
        }}
      >
        Ver más detalles
      </Typography>
    </Box>
  );
}














